export const TPP_ACCOUNT_NO = "25712";
export const TPP_USER_ID = "4686-API";
export const TPP_PASSWORD = "e1b0b9";